import Api from 'services/api';
import apiURLBuilder from 'core/apiURLBuilder'

const generateOtp = operationId => {
    const params = {
        operationId,
    };
    return Api.get(apiURLBuilder.getURL('generateOtpUniversia', params));
};

const verifyOtp = ({ id, userProfile }) => {
    const params = {
        id,
    };
    const payload = {
        header: {},
        query: { otpCode: userProfile.universiaName },
    };
    return Api.post(apiURLBuilder.getURL('verifyOtpUniversia', params), payload);
};

export { generateOtp, verifyOtp };
